import { isFieldErrorResponse, useApiAccountsV1SignupVerifyCreate } from 'api';
import { AuthLayout, OtpForm, type OtpFormValues, OtpIcon, useNotification } from 'features';
import { safiLogo } from 'features/brand';
import { useTranslation } from 'i18n';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { getAuthRoute } from '../../utils/getAuthRoute';

export const SignUpVerify = () => {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');
  const { open } = useNotification();
  const navigate = useNavigate();

  const { mutate, isPending } = useApiAccountsV1SignupVerifyCreate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          open({
            description:
              error?.response?.data.email_verification_code?.[0] ?? error?.response?.data.non_field_errors?.[0],
            message: t('notifications.errorVerifyingPasscode'),
            type: 'error',
          });
          return;
        }
        open({
          message: t('notifications.errorVerifyingPasscode'),
          type: 'error',
        });
      },
      onSuccess() {
        navigate(getAuthRoute('/sign-up/company'));
      },
    },
  });
  const handleSubmit = (data: OtpFormValues) => {
    mutate({
      data,
    });
  };
  return (
    <AuthLayout
      title={t('shared.marketingTitle')}
      subtitle={t('shared.marketingSubtitle', { values: { brandName: tCommon('brand.name') } })}
      logo={safiLogo}
    >
      <OtpIcon variant="email" />
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {t('signUpVerify.welcome', { values: { brandName: tCommon('brand.name') } })}
      </Typography>
      <Typography>{t('signUpVerify.emailPasscodeHint', { values: { brandName: tCommon('brand.name') } })}</Typography>

      <OtpForm onSubmit={handleSubmit} isLoading={isPending} />

      <Link component={RouterLink} to={getAuthRoute('/sign-up')}>
        {t('shared.goBack')}
      </Link>
    </AuthLayout>
  );
};
